import * as React from 'react';
import { ButtonVariant } from '@packages/ui/components/buttons/types';
import { FixedRatio, BreakpointFlag, Button, SchemalessResponsiveImage } from '@packages/ui';

import { SmartLink } from '../../SmartLink';
import {
  StyledInnerWrapper,
  StyledTitle,
  StyledSubitle,
  StyledCenteredFlex,
  StyledCTAWrapper,
} from './HeroBannerWithCTAButtonsStyleComponents';
import { useGetDyImageSources } from '../utils/useGetDyImageSources';
import type { CTAButton, CustomizableText, DyImages } from '../types';
export interface HeroBannerWithCTAButtonsProps {
  onClick: VoidFunction;
  title?: CustomizableText;
  subtitle?: CustomizableText;
  ctas: CTAButton[];
  ctaType: ButtonVariant;
  images: DyImages;
}

export const HeroBannerWithCTAButtons: React.FC<HeroBannerWithCTAButtonsProps> = ({
  images,
  title = {},
  subtitle = {},
  ctas,
  ctaType,
  onClick,
}) => {
  const { text: titleText, color: titleColor, size: titleSize = 13 } = title;
  const { text: subtitleText, color: subtitleColor, size: subtitleSize = 6 } = subtitle;

  const { desktop, tablet, mobile } = images;
  const mobileRatio = Number(mobile.height) / Number(mobile.width);
  const tabletRatio = Number(tablet.height) / Number(tablet.width);
  const desktopRatio = Number(desktop.height) / Number(desktop.width);

  const { sources, cdnProvider } = useGetDyImageSources(images);
  const [mobileSrc, tabletSrc, desktopSrc] = sources;

  return (
    <FixedRatio ratio={[mobileRatio, mobileRatio, tabletRatio, desktopRatio]}>
      <StyledInnerWrapper>
        {title && (
          <StyledTitle fontSize={titleSize} color={titleColor}>
            {titleText}
          </StyledTitle>
        )}
        {subtitle && (
          <StyledSubitle fontSize={subtitleSize} color={subtitleColor}>
            {subtitleText}
          </StyledSubitle>
        )}
        {ctas.length > 0 && (
          <StyledCenteredFlex pt={2}>
            <StyledCenteredFlex flexDirection={['column', 'column', 'row']}>
              {ctas.map(({ text, linkUrl }, idx) => {
                return (
                  <StyledCTAWrapper key={`cta-${idx}`} onClick={onClick}>
                    <SmartLink linkUrl={linkUrl} target="_self">
                      <Button variant={ctaType}>{text}</Button>
                    </SmartLink>
                  </StyledCTAWrapper>
                );
              })}
            </StyledCenteredFlex>
          </StyledCenteredFlex>
        )}
      </StyledInnerWrapper>
      <SchemalessResponsiveImage
        cdnProvider={cdnProvider}
        mapping={{
          [BreakpointFlag.SM]: mobileSrc,
          [BreakpointFlag.MD]: tabletSrc,
          [BreakpointFlag.LG]: desktopSrc,
        }}
      />
    </FixedRatio>
  );
};
